<main>
  @if (showLanguageSelector) {
    <div class="language-selector-wrapper">
      <app-language-selector></app-language-selector>
    </div>
  }
  <router-outlet></router-outlet>
</main>
